module.exports = __webpack_public_path__ + "static/media/youtubeclone.a127c409.webp";